
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// @mui material components
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/img.jpg";
import OTPVerification from "./OTPVerification";
// Encryption Functions
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
function Register() {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    passwordConfirm: "",
    role: "admin",
  });
  const navigate = useNavigate();
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!formData.email || !formData.password || !formData.passwordConfirm) {
      toast.error("All fields are required");
      return;
    }
  
    if (formData.password !== formData.passwordConfirm) {
      toast.error("Passwords do not match");
      return;
    }
  
    try {
      const secretKey = await fetchSecretKey();
      const encryptedData = encryptBody(
        {
          email: formData.email,
          password: formData.password,
          passwordConfirm: formData.passwordConfirm,
          role: formData.role,
        },
        secretKey
      );
  
      // Register Dealer
      const response = await axios.post("/api/register", encryptedData, {
        headers: {
          "Content-Type": "text/plain",
          
        },
      });
  
      if (response.status === 200) {
        const decryptedResponse = decryptBody(response.data, secretKey);
  
        if (!decryptedResponse) {
          throw new Error("Decryption failed, no data returned.");
        }
        if (decryptedResponse.success === "true") {
          
  
          toast.success("Registered Successfully! Check your email for OTP.");
          setFormData({ email: "", password: "", passwordConfirm: "", role: "admin" });
  
          setTimeout(() => {
            navigate(`/OTPVerification?email=${formData.email}`);
          }, 100);
        } else {
          toast.error(decryptedResponse?.message || "Failed to verify registration.");
        }
      }
    } catch (error) {
      console.error("Registration Error:", error);
      toast.error(error.response?.data || "Registration failed");
    }
  };
  
  return (
    <BasicLayout image={bgImage}>
      <Card>
      <MDBox pt={2} pb={3} px={3}>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
  <img
    className="mb-3"
    src="/careconnect.jpg"
    alt="logo"
    style={{ height: "80px", marginTop: "10px" }} 
  />
</div>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit}>
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                fullWidth
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                fullWidth
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Confirm Password"
                fullWidth
                name="passwordConfirm"
                value={formData.passwordConfirm}
                onChange={handleChange}
                required
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="success" fullWidth>
                Sign Up
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}
export default Register;
